import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";
// GenerateQualidadeProvisaoRecursoColumns

// Função auxiliar para formatar em Reais
const formatCurrency = (value: number | null | undefined) => {
  if (value === null || value === undefined) return "";
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

type Props = {
  onActionEditar: ( Id: number | null, openState: boolean) => void,
  onActionDeletar: ( Id: number | null, openState: boolean) => void,
};

export const GenerateQualidadeProvisaoRecursoColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {

  return [
    {
      field: "Recurso", 
      filterable: false,
      headerName: "Recurso", 
      flex: 1,
      minWidth: 75,
      width: 75,
      sortable: false,
    },
    {
      field: "DataPrevistaDe",
      filterable: false,
      headerName: "Data de Início",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (<span>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</span>);
      },
    },
    {
      field: "DataPrevistaAte",
      filterable: false,
      headerName: "Data de Término",
      flex: 1,
      minWidth: 150,
      sortable: false,
       renderCell: (params) => {
        return (<span>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</span>);
      },
    },
    {
      field: "ValorPrevisto",
      filterable: false,
      headerName: "Valor Previsto",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<span>{formatCurrency(params.value)}</span>);
      },
    },
    {
      field: "ValorDesembolsado",
      filterable: false,
      headerName: "Valor Desembolsado",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<span>{formatCurrency(params.value)}</span>);
      },
    },
    {
    field: 'IdProvisaoRecurso',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    minWidth: 100,

    renderCell: (params) => {
      return (
        <div className="flex items-center justify-center w-full h-full gap-1">
          
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)} >
            <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
          </IconButton>

        </div>
      );
    }
    },
  ];
}